<template>
  <b-modal :id="modalId" hide-footer>
    <template #modal-title v-if="title">
      {{title}}
    </template>

    <slot>
      <div class="d-block text-center">
        <h3>Content!</h3>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide(modalId)">Close Me</b-button>
    </slot>

  </b-modal>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    title: {
      require: false,
      type: String,
    },
    modalId: {
      require: true,
      type: String,
    },
  },
};
</script>
